// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"6316c856","324":"3ef25b74","472":"fbfbe481"}[chunkId] + ".chunk.js";
};